
        module.exports = __webpack_public_path__ + "assets/images/itfworld-logo-white.891d422e.svg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 428,
            height: 250,
            type: "svg",
            bytes: 1526,

            toString: function() {
                return src;
            }
        };
    